import {I18N_VALIDATIONS_KEY, I18N_VALUE_CODE_KEY, I18N_VALUE_HELP_MESSAGE_KEY} from 'lf-at-theme';
import {DISALLOWED_VALUE_CODE} from "@lightweightform/storage";

/**
 * Union form i18n object for the en-US locale.
 */
export const unionFormI18nEnUS: Record<string, any> = {
  '/union-form': {
    label: 'Union Scheme - Registration',
  },

  '/?/meetsConditions': {
    label: 'I confirm that I meet the conditions to register for this scheme.'
  },

  '/?/currVatId': {
    netpVat: 'VAT Identification Number',
    netpHelp: 'Individual VAT identification number allocated by the Member State of identification in accordance with Article 369d of Directive 2006/112/EC, including the country code'
  },

  '/?/notEstablishedInEU': {
    [I18N_VALUE_CODE_KEY]: '16.1',
    label: 'Not established in EU'
  },


  '/union-form/actsAsVatGroup': {
    [I18N_VALUE_CODE_KEY]: '20',
    label: 'VAT Group?'
  },

  '/union-form/actsAsElectronicInterface': {
    [I18N_VALUE_CODE_KEY]: '16.2',
    label: 'Electronic Interface'
  },

  '/?/countryOfBusiness': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Country in which the taxable person has his place of business if not in the Union'
  },

  '/?/fixedEstablishments/?/hasRealEstablishment': {
    [I18N_VALUE_CODE_KEY]: '13.1',
    label: 'Has a fixed establishment',
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Fixed establishment for VAT purposes. Allows you to declare the supply of services from this establishment. Prohibits declaring the supply of services to the country of this establishment as a Member State of Consumption',
    [I18N_VALIDATIONS_KEY]: {
      [DISALLOWED_VALUE_CODE]: ({allowedValues, value}, ctx) => {
        if (ctx.get('/union-form/notEstablishedInEU')) {
          return 'Cannot declare to have a fixed establishment in other Member-State when ' +
            '[Not established in EU](lf:///union-form/notEstablishedInEU) is filled-in.'
        } else {
          return `AllowedValues: ${allowedValues.join(', ')}.`
        }
      }
    }
  },

  '/?/fixedEstablishments/?/taxIdentif/vatIdNum': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Individual VAT identification number(s) or, if not available, tax reference number(s) allocated by the Member State(s) in which the taxable person has a fixed establishment(s) other than the Member State of identification and by the Member State(s) where goods are dispatched or transported from other than the Member State of identification.'
  },

  '/?/fixedEstablishments/?/taxIdentif/taxRefNum': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Tax Reference Number given by the Member State'
  },


  '/?/idsInOtherMSs': {
    label: 'Identification in other EU countries',
    headerText: 'Identification in other EU countries',
    [I18N_VALUE_CODE_KEY]: '15.1',
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'VAT identification number(s) allocated by Member State(s) as a non-established taxable person'
  },

  '/?/prevOrCurrOssVatId': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Individual VAT identification number(s) allocated by the Member State of identification in accordance with Articles 362, 369d or 369q of Directive 2006/112/EC if the taxable person has previously used or is currently using one of these schemes'
  },


  // Relevant Dates
  '/?/relevantDates/registrationReqDate': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Date of request by the taxable person to be registered under the scheme'
  },
};
